export default "__VITE_ASSET__D5rnxAhP__"